import React from 'react'
import AnalyticsFilterComponent from './AnalyticsFilterComponent'

const CardFilter = ({
  filter = {}, onChange, tooltipContent = 'Filter this card', currencyOptions,
  title, titleLoading, titleClassName, headerClassName, actions, disabled = false,
}) => {
  const dateRangeMenu = {
    date_from: { title: 'Date From', inputType: 'date', maxDateKey: 'date_to' },
    date_to: { title: 'Date To', inputType: 'date', minDateKey: 'date_from' },
  }

  const currencyMenu = currencyOptions?.length ? {
    currency: {
      title: 'Currency',
      inputType: 'dropdown',
      options: currencyOptions,
      valueKey: 'id',
      labelKey: 'name',
    },
  } : {}

  const filterMenu = { ...dateRangeMenu, ...currencyMenu }

  return (
    <AnalyticsFilterComponent
      filter={filter}
      filterMenu={filterMenu}
      getResponseBack={onChange}
      tooltipContent={tooltipContent}
      className="ca-card-filter"
      title={title}
      titleLoading={titleLoading}
      {...(titleClassName && { titleClassName })}
      {...(headerClassName && { headerClassName })}
      actions={actions}
      disabled={disabled}
    />
  )
}

export default CardFilter
